module.exports = __webpack_public_path__ + "img/club_background.f2b1cf32.png";